import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MstVisitService} from '../configuration/mst-visit/mst-visit.service';

@Component({
  selector: 'app-patient-chart',
  templateUrl: './patient-chart.component.html',
  styleUrls: []
})
export class PatientChartComponent implements OnInit {
  visit_id_url: string;
  linkSource: any;
  visit_id: any;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private mstVisitService: MstVisitService) {
  }

  ngOnInit() {
    this.visit_id = '';
    const a = this.router.url.split('/'); //  Delimiter is a string
    this.linkSource = a[3];
    this.visit_id = a[4];
    // for (let i = 0; i < a.length; i++) {
    //   //  alert(i + '' + a[i]);
    //   if (i === 3) {
    //     this.linkSource = a[i];
    //   }
    //   if (i === 4) {
    //     this.visit_id = a[i];
    //   }
    // }
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/patient-chart/patient-chart.component.ts